import { JSX, useCallback } from "react";
import { useTranslation } from "react-i18next";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { SxProps, Theme } from "@mui/material/styles";

import { asTitle } from "utils/Utils";

import { Tabs } from "./RolesOverview";

export interface RolesHeaderProps {
	selected: Tabs;

	onSelect: (selected: Tabs) => void;
}

function RolesHeader(props: RolesHeaderProps): JSX.Element {
	const { t } = useTranslation();

	function getStyle(tab: Tabs): SxProps<Theme> {
		if (props.selected === tab) {
			return { textDecoration: "underline", cursor: "pointer" };
		} else {
			return { cursor: "pointer" };
		}
	}

	const selectInformation = useCallback(() => {
		props.onSelect(Tabs.INFORMATION);
	}, []);

	const selectEvaluation = useCallback(() => {
		props.onSelect(Tabs.EVALUATION);
	}, []);

	const selectReports = useCallback(() => {
		props.onSelect(Tabs.REPORTS);
	}, []);

	const selectAdmin = useCallback(() => {
		props.onSelect(Tabs.ADMIN);
	}, []);

	return (
		<Grid container alignItems="center">
			<Grid item xs={4} sm={5} md={5} lg={6}>
				<Typography variant="subtitle2">
					{asTitle(t("tabs"))}
				</Typography>
			</Grid>
			<Grid item xs={8} sm={7} md={5} lg={4}>
				<Grid
					container
					spacing={2}
					flexWrap="nowrap"
					justifyContent="flex-end">
					<Grid item>
						<Typography
							sx={getStyle(Tabs.INFORMATION)}
							variant="subtitle2"
							onClick={selectInformation}>
							{asTitle(t("information"))}
						</Typography>
					</Grid>
					<Grid item>
						<Typography
							sx={getStyle(Tabs.EVALUATION)}
							variant="subtitle2"
							onClick={selectEvaluation}>
							{asTitle(t("evaluation"))}
						</Typography>
					</Grid>
					<Grid item>
						<Typography
							sx={getStyle(Tabs.REPORTS)}
							variant="subtitle2"
							onClick={selectReports}>
							{asTitle(t("report_other"))}
						</Typography>
					</Grid>
					<Grid item>
						<Typography
							sx={getStyle(Tabs.ADMIN)}
							variant="subtitle2"
							onClick={selectAdmin}>
							{asTitle(t("adminRights"))}
						</Typography>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}

export default RolesHeader;
